import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from './util.service';
import { Observable } from 'rxjs';
import { IVehicle, IResponse } from '@signal/asp-data-commons';
import {map, switchMap} from 'rxjs/operators';
import {Store} from '@ngrx/store';
import {DealerState} from '../../store/dealer/dealer.reducer';
import {selectDealerCode} from '../../store/dealer/dealer.selectors';

@Injectable()
export class CustomerService {
    private aspAppointmentApi: string;
    private readonly baseApi: string;
  constructor(private http: HttpClient,
              private readonly dealerState: Store<DealerState>) {
        this.aspAppointmentApi = environment.aspAppointmentApi;
        this.baseApi = environment.baseApi;
    }

    getCustomerVehicles(customerId): Observable<IResponse<IVehicle[]>> {
      return this.dealerState.select(selectDealerCode).pipe(switchMap(dealerCode => {
        return this.http.get(`${(this.aspAppointmentApi)}consumer/${dealerCode}/vehicles/${customerId}`).pipe(
            map((data: IResponse<IVehicle[]>) => {
                return data;
            }
            )
        );
      }));
    }

    getApptBySignalDeepLink(customerId) {
      return this.http.get(`${this.baseApi}/appointment/get-appointment/${customerId}`).pipe(
        map((data: any) => {
          return data
        })
      )
    }

}
